
/**
 * Merges the historical forecast and observations timestamps graph
 * @param {*} histTemp 
 * @param {*} obsvTemp 
 * @returns 
 */
export function timestampMerger(histTemp, obsvTemp) {
    // Combine the two charts
    const comboTimeline = [];

    const histTempLen = histTemp.length;
    const obsvTempLen = obsvTemp.length;
    let histTempCounter = 0;
    let obsvTempCounter = 0;

    const maxIter = 10000;

    if(histTempLen < 0 && obsvTempLen < 0) return; 

    let counter = 0;

    while(counter < maxIter) {
        let histTempDate = null;
        let obsvTempDate = null;

        if(histTempCounter < histTempLen) {
            histTempDate = new Date(histTemp[histTempCounter]['StationDatetime']);
        }
        
        if(obsvTempCounter < obsvTempLen) {
            obsvTempDate = new Date(obsvTemp[obsvTempCounter]['StationDatetime']);
        }

        if((obsvTempCounter >= obsvTempLen && histTempCounter >= histTempLen) ||
                obsvTempDate == null && histTempDate == null) {
            break;
        }
        
        if(obsvTempDate && histTempDate == null) {
            comboTimeline.push(obsvTempDate);
            obsvTempCounter += 1;
        } else if(histTempDate && obsvTempDate == null) {
            comboTimeline.push(histTempDate);
            histTempCounter += 1;
        } else if(histTempDate.getTime() === obsvTempDate.getTime()) {
            comboTimeline.push(histTempDate);
            histTempCounter += 1;
            obsvTempCounter += 1;
        } else if(histTempDate.getTime() > obsvTempDate.getTime()) {
            comboTimeline.push(obsvTempDate);
            obsvTempCounter += 1;
        } else if(histTempDate.getTime() < obsvTempDate.getTime()) {
            comboTimeline.push(histTempDate);
            histTempCounter += 1;
        } else {
            console.error("UNHANDLED TEMPERATURE GRAPH CASE");
            return;
        }
        
        counter += 1;
    }  

    return comboTimeline;
}